import type {
  ShiftSegment,
  TrendsPageFilterStateType,
  ProcessGroup,
  Process,
} from "../../../types/types";
import { uniq } from "lodash";

export const ALL_GROUP_NAME_DISPLAY = "All";
export const ALL_PROCESS_NAME_DISPLAY = "All";
export const ALL_TAG_NAME_DISPLAY = "All";
export const ALL_PNL_CATEGORY_NAME_DISPLAY = "All";
export const ALL_SHIFT_NAME_DISPLAY = "All";

export const FILTER_TYPES = {
  group: "group",
  shiftName: "shiftName",
  tag: "tag",
  process: "process",
  /** ! at the moment we don't have a pnlCategory filter UI, it's all handled in tag filter UI */
  pnlCategory: "pnlCategory",
  workScheduleId: "workScheduleId",
};

export function isVariationOfAll(filterValue: string): boolean {
  return Boolean(
    (filterValue &&
      String(filterValue).toLowerCase().slice(0, 3) === "all" &&
      String(filterValue).toLowerCase().slice(0, 5) !== "all -") ||
      filterValue === "Overall" ||
      filterValue === "Overview"
  );
}

export const createAllProcessGroup = (ckey: string): ProcessGroup => {
  return {
    groupSortIdx: ALL_PROCESS_NAME_DISPLAY,
    summaryGroup: ALL_PROCESS_NAME_DISPLAY,
    longName: ALL_PROCESS_NAME_DISPLAY,
    shortName: ALL_PROCESS_NAME_DISPLAY,
    output: null,
    outputLabel: "parts",
    isIdleUntagged: false,
    showCountNotMetricOnGroupTile: false,
    ckey,
    processes: [
      {
        id: ALL_PROCESS_NAME_DISPLAY,
        isSelected: true,
        ckey,
        name: ALL_PROCESS_NAME_DISPLAY,
        showCountNotMetricOnGroupTile: false,
        workScheduleConfig: {
          id: "1",
        },
        taps: [
          {
            id: ALL_PROCESS_NAME_DISPLAY,
            machemetryId: ALL_PROCESS_NAME_DISPLAY,
            name: ALL_PROCESS_NAME_DISPLAY,
          },
        ],
      },
    ],
  };
};

export function groupShiftsByName(shifts: ShiftSegment[]) {
  return shifts.reduce(
    (acc, shift) => {
      if (shift.shift.name) {
        acc[shift.shift.name] = [...(acc[shift.shift.name] || []), shift];
      }
      return acc;
    },
    { [ALL_SHIFT_NAME_DISPLAY]: shifts } // default "All" group
  );
}

export function getFilteredProcessesFromFilterState(
  trendsPageFilterState: TrendsPageFilterStateType,
  visibleGroups: ProcessGroup[],
  visibleProcesses: Process[]
): Process[] {
  let filteredProcessesArrays = [] as Process[][];

  const [groupName, processName, processId] = [
    trendsPageFilterState.group,
    trendsPageFilterState.process.name,
    trendsPageFilterState.process.id,
  ];
  const isAllGroupSelected = groupName === ALL_GROUP_NAME_DISPLAY;
  const isAllProcessSelected = processName === ALL_PROCESS_NAME_DISPLAY;

  // filter state can only have one of group or process not equal to "All"
  if (isAllGroupSelected && isAllProcessSelected && visibleProcesses) {
    filteredProcessesArrays = [visibleProcesses];
  } else if (isAllGroupSelected) {
    // find process matching the processName
    const process =
      visibleProcesses && visibleProcesses.find(p => p.id === processId);
    if (process) {
      filteredProcessesArrays = [[process]];
    }
  } else if (isAllProcessSelected) {
    const trendsPageFilteredGroupsArr = [groupName].map(g => g.toLowerCase());

    const isAllGroup = isVariationOfAll(groupName);

    const filteredGroups = isAllGroup
      ? visibleGroups
      : visibleGroups.filter(({ longName }) =>
          trendsPageFilteredGroupsArr.includes(longName.toLowerCase())
        );

    filteredProcessesArrays = filteredGroups.map(g => g.processes);
  }
  return uniq(
    filteredProcessesArrays.reduce((acc, cur) => [...acc, ...cur], [])
  );
}
